import { render, staticRenderFns } from "./OnestoreSubscribe.vue?vue&type=template&id=31117434&"
import script from "./OnestoreSubscribe.vue?vue&type=script&lang=js&"
export * from "./OnestoreSubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports